import { create } from 'zustand'
import { ProjectPropertiesStoreType } from './types/types'

interface AssignedUserList {
    userName: string
    userId?: string | null
}

/**
 * Creates a zustand store for managing workspace projectproperties state
 * @returns {ProjectPropertiesStoreType} A reactive store with workspace management methods
 */
export const useProjectPropertiesStore = create<ProjectPropertiesStoreType>()(
    (set) => ({
        assignedUsersList: [
            { userName: 'Unassigned', userId: null },
        ] as AssignedUserList[],
        setAssignedUsersList: (users: AssignedUserList[]) => {
            set({ assignedUsersList: users })
        },
    })
)
